import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import Foa from './containers/foa'
import Poc from './containers/poc'
import PocV3 from './containers/pocv3'
import Ex160 from './containers/ex160'
import Part36 from './containers/part36'
import NotPart36 from './containers/notPart36'
import Cfa from './containers/cfa'
import FoaV2 from './containers/foaV2'
import CfaTransfer from './containers/cfaTransfer'
import CfaTransferOA from './containers/cfaTransferOA'
import IdUploadOA from './containers/idUploadOA'
import OpenLetter from './containers/openLetter'
import CfaUpdateOpopClients from './containers/cfaUpdateOpopClients'
import ConsentOpenBanking from './containers/consentOpenBanking'
import CfaLitigation from './containers/cfa-litigation'
import LoaLitigation from './containers/loa-irresponsibleLending'
import LoaIrresponsibleLending from './containers/loa-irresponsibleLending'
import Unsub from './containers/unsubscribe'
import DsarLoa from './containers/dsarLoa'
import DsarLoaDobConf from './containers/dsarLoaDobConf'
import OpenLetterFca__FOIA from './containers/openLetterFCA_FOIA'
import CfaLC from './containers/cfa-lc'
import CfaLCSR from './containers/cfa-lc-sr'
import CfaSD from './containers/cfa-sd'
import CfaSO from './containers/cfa-so'
import CfaGorilla from './containers/cfa-gorilla'
import LoaIns from './containers/loaIns'
import CfaAllegiant from './containers/cfa-allegiant'
import LoaOptions from './containers/loaOptions'
import CfaOARetransfer from './containers/cfa-oa-retransfer'
import CfaLCIL from './containers/cfa-lc-il'
import SignHearingLoss from './containers/signHearingLoss'
import CfaReferral from './containers/cfa-referral'
import Contract from './containers/contract'

export default function AppRouter() {
    // Router
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route index element={<Foa />} />
                    <Route path="foa" element={<Foa />} />
                    <Route path="foa/:token" element={<Foa />} />
                    <Route path="foa-v2" element={<FoaV2 type={'foa-v2-signature'} />} />
                    <Route path="foa-v2/:token" element={<FoaV2 type={'foa-v2-signature'} />} />
                    <Route path="foa-v2-additional" element={<FoaV2 type={'foa-v2-additional-signature'} />} />
                    <Route path="foa-v2-additional/:token" element={<FoaV2 type={'foa-v2-additional-signature'} />} />
                    <Route
                        path="foa-v2-resign/:token"
                        element={<FoaV2 type={'foa-v2-additional-signature-resign'} />}
                    />
                    <Route path="loa-ins" element={<LoaIns />} />
                    <Route path="loa-ins/:token" element={<LoaIns />} />
                    <Route path="poc" element={<Poc />} />
                    <Route path="poc/:token" element={<Poc />} />
                    <Route path="poc-new" element={<Poc />} />
                    <Route path="poc-new/:token" element={<Poc />} />
                    <Route path="poc-resend" element={<Poc />} />
                    <Route path="poc-resend/:token" element={<Poc />} />
                    <Route path="pocv3-new" element={<PocV3 />} />
                    <Route path="pocv3-new/:token" element={<PocV3 />} />
                    <Route path="pocv3-resend" element={<PocV3 />} />
                    <Route path="pocv3-resend/:token" element={<PocV3 />} />
                    <Route path="ex160" element={<Ex160 />} />
                    <Route path="ex160/:token" element={<Ex160 />} />
                    <Route path="part36" element={<Part36 />} />
                    <Route path="part36/:token" element={<Part36 />} />
                    <Route path="not-part36" element={<NotPart36 />} />
                    <Route path="not-part36/:token" element={<NotPart36 />} />
                    <Route path="cfa" element={<Cfa />} />
                    <Route path="cfa/:token" element={<Cfa />} />
                    <Route path="cfa-transfer" element={<CfaTransfer />} />
                    <Route path="cfa-transfer/:token" element={<CfaTransfer />} />
                    <Route path="cfa-transfer-oa" element={<CfaTransferOA />} />
                    <Route path="cfa-transfer-oa/:token" element={<CfaTransferOA />} />
                    <Route path="cfa-update/" element={<CfaUpdateOpopClients />} />
                    <Route path="cfa-update/:token" element={<CfaUpdateOpopClients />} />
                    <Route path="id-upload-oa/:token" element={<IdUploadOA />} />
                    <Route path="open-letter" element={<OpenLetter />} />
                    <Route path="open-letter-foia" element={<OpenLetterFca__FOIA />} />
                    <Route path="affordability-consent/:token" element={<ConsentOpenBanking />} />
                    <Route path="cfa-litigation/:token" element={<CfaLitigation />} />
                    <Route path="cfa-lc/:token" element={<CfaLC />} />
                    <Route path="cfa-lc-sr/:token" element={<CfaLCSR />} />
                    <Route path="cfa-salesone/:token" element={<CfaSO />} />
                    <Route path="dsar-loa/:token" element={<DsarLoa />} />
                    <Route path="dsar-loa-dob-conf/:token" element={<DsarLoaDobConf />} />
                    <Route path="unsubscribe" element={<Unsub />} />
                    <Route path="loa-irresponsibleLending/:token" element={<LoaIrresponsibleLending />} />
                    <Route path="cfa-sd/:token" element={<CfaSD />} />
                    <Route path="cfa-sd-sign/:token" element={<CfaSD />} />
                    <Route path="cfa-allegiant/:token" element={<CfaAllegiant />} />
                    <Route path="cfa-allegiant-sign/:token" element={<CfaAllegiant />} />
                    <Route path="cfa-gorilla/:token" element={<CfaGorilla />} />
                    <Route path="cfa-gorilla-sign/:token" element={<CfaGorilla />} />
                    <Route path="loa-options/:token" element={<LoaOptions />} />
                    <Route path="cfa-lc-il/:token" element={<CfaLCIL />} />
                    <Route path="cfa-oa-retransfer/:token" element={<CfaOARetransfer />} />
                    <Route path="nihl/:caseRef" element={<SignHearingLoss />} />
                    <Route path="cfa-referral/:token" element={<CfaReferral />} />
                    <Route path="contract/:token" element={<Contract />} />
                </Route>
            </Routes>
        </Router>
    )
}
